import { calculateDistanceSquared } from "./calculateDistSquared";

export const calculateNearestPoint = (points = [], clickedLatLng = {}) => {
  if (!points.length) {
    return;
  }

  let minDistanceSq = Infinity;
  let closestIndex = -1;

  points.forEach((point, index) => {
    const distanceSq = calculateDistanceSquared(clickedLatLng, point);
    if (distanceSq < minDistanceSq) {
      minDistanceSq = distanceSq;
      closestIndex = index;
    }
  });

  if (closestIndex !== -1) {
    const info = {
      index: closestIndex,
      point: points[closestIndex],
      // Convert squared distance back if needed: Math.sqrt(minDistanceSq)
      distanceSq: minDistanceSq,
    };

    return info;
  }
  return null;
};
